// extracted by mini-css-extract-plugin
export default {"quickLists":"quickList_quickLists__8BaGb","quickList":"quickList_quickList__i8DHn"};